
















































import { Component, Vue } from 'vue-property-decorator'
import api from '@/api'
import constants from '@/utils/constants'
import PosOrderTypeWithEDCStep from '@/components/PosOrderTypeWithEDCStep.vue'
import LoadingWithText from '@/components/LoadingWithText.vue'
import { isEmpty } from 'lodash-es'

@Component({
  components: {
    LoadingWithText,
    PosOrderTypeWithEDCStep
  }
})
export default class EDCHomepage extends Vue {
  get userType() {
    return this.$store.state.currentUser
      ? this.$store.state.currentUser.Type
      : ''
  }

  isAdmin: boolean = this.userType === 'Admin'
  fetching: boolean = false
  togglePosOrder: boolean = false
  toggleCIMBSettlement: boolean = false
  posOrderModel: string | null = null
  posOrderOutlet: any = localStorage.getItem('pos-order-outlet')
    ? JSON.parse(localStorage.getItem('pos-order-outlet') as string)
    : null
  outletData: any = localStorage.getItem('outletData')
    ? JSON.parse(localStorage.getItem('outletData') as string)
    : null
  isTestMode: boolean = false
  $swal: any

  get userUid() {
    return localStorage.getItem('UID')
  }

  async mounted() {
    sessionStorage.removeItem('cartListInfo')
    sessionStorage.removeItem('qrCode')
    sessionStorage.removeItem('payCallBackInfo')
    sessionStorage.removeItem('orderId')
    if (
      sessionStorage.getItem('edc_step') &&
      sessionStorage.getItem('clicked_kembali')
    ) {
      this.togglePosOrder = true
    }

    if (!this.posOrderOutlet) {
      const outletCodes = localStorage
        .getItem('outletCodes')!
        .split(',')
        .filter(item => !!item)

      let outletInfo: any[] = []
      if (this.isAdmin || outletCodes.length) {
        this.fetching = true
        await api
          .GetAllStoreForNewPort(
            { page: 1, size: 1 },
            { byField: '', isDesc: '' },
            {},
            this.userUid
          )
          .then(res => {
            try {
              const data = res.data.result.data
              if (data) {
                for (let index = 0; index < data.length; index++) {
                  const element = data[index]
                  outletInfo.push({
                    outletType: element.type,
                    value: element.outlet_code,
                    text: element.outlet_code + ' - ' + element.name,
                    ...element
                  })
                }
              }
            } catch (error) {
              throw error
            }
          })
          .finally(() => {
            this.fetching = false
          })
        if (outletInfo.length) {
          this.posOrderOutlet = outletInfo[0]
          this.isTestMode = this.posOrderOutlet.is_test_mode
          localStorage.setItem(
            'pos-order-outlet',
            JSON.stringify(outletInfo[0])
          )
          localStorage.setItem('selected-outlet', JSON.stringify(outletInfo[0]))
        }
      }
    } else {
      this.isTestMode = this.posOrderOutlet.is_test_mode
    }
    if (!isEmpty(this.outletData.edc_cimb_payment) &&
      (this.outletData.edc_cimb_payment.qris ||
        this.outletData.edc_cimb_payment.debit ||
        this.outletData.edc_cimb_payment.credit)) {
      console.log(this.outletData.edc_cimb_payment)
      this.toggleCIMBSettlement = true
    }

    // Call Android JS after data loading complete
    if (window && typeof (window as any).android !== 'undefined') {
      (window as any).android.onLoadFinished()
    }
  }

  hidePosOrder() {
    this.posOrderModel = null
    this.togglePosOrder = false
  }

  onSale() {
    sessionStorage.removeItem('pin_code')
    if (this.posOrderOutlet && this.posOrderOutlet.id) {
      if (!this.outletData || this.outletData.id !== this.posOrderOutlet.id) {
        this.fetching = true
        this.$store
          .dispatch('GetOneStoreForNewPort', this.posOrderOutlet.id)
          .then(res => {
            const order_types = res.data.result.order_types.filter(
              item => item !== constants.OTHERS
            )
            res.data.result.order_types = order_types
            if (!res.data.result.order_types.length) {
              return this.$swal(
                constants.SOMETHING_WROING,
                'This outlet is not allowed to create order',
                constants.STATUS_ERROR
              )
            }
            this.outletData = res.data.result
            this.togglePosOrder = true
          })
          .catch(() => {
            this.$swal(
              constants.SOMETHING_WROING,
              'Can\'t get the outlet setting',
              constants.STATUS_ERROR
            )
          })
          .finally(() => {
            this.fetching = false
          })
      } else {
        this.togglePosOrder = true
      }
    } else {
      return this.$swal(
        constants.SOMETHING_WROING,
        'Select an outlet to continue',
        constants.STATUS_ERROR
      ).then(res => {
        if (res) {
          this.$router.push(`/order-report`)
        }
      })
    }
  }

  onRealSale() {
    sessionStorage.removeItem('is-test-mode')
    this.onSale()
  }

  onTestSale() {
    sessionStorage.setItem('is-test-mode', 'true')
    this.onSale()
  }

  openCheckCoupon() {
    this.posOrderModel = constants.EDC_ORDER_MODEL.checkCoupon
    this.onSale()
  }

  startCIMBSettlement() {
    if (window && typeof (window as any).android !== 'undefined') {
      (window as any).android.settlementCimbPayment()
    } else {
      this.$swal(
        constants.SOMETHING_WROING,
        'need to settlement CIMB payment in android',
        constants.STATUS_ERROR
      )
    }
  }
}
